<script>
export default {
    props: {
        disabled: Boolean,
        size: String,
    },
    computed: {
        btnClass() {
            console.log('this', this.size)
            if (this.disabled) {
                return 'disabled'
            }
        },
    },
    methods: {
        click() {
            // if (!this.disabled) {
            this.$emit('click')
            // }
        }
    }
}
</script>

<template>
<el-button class="elementButton" :size="size" :class="btnClass" @click="click">
    <slot></slot>
</el-button>
</template>

<style lang="scss" scoped>
@import './css/color.scss';
@import './css/common.scss';

.elementButton {
    display: inline-block;
    background-color: $mainPurple;
    color: #fff;
    cursor: pointer;
    border-radius: 4px;
    border-color: #00ADC7;
    &:hover {
        background-color: #00ADC7;
    }

    @extend %center;
}

.disabled {
    background-color: #dadada;
    cursor: not-allowed;

    &:hover {
        background-color: #00ADC7;
    }
}
</style>



// WEBPACK FOOTER //
// yotta-vue-components/vision/elementButton.vue